export const EmitVideoEvent = 'Applet.ActiveEmitVideoEvent';
export interface EmitVideoEvent {
	type: typeof EmitVideoEvent;
	event: {
		type: 'ended' | 'error' | 'stopped';
		srcArguments: {
			uri: string;
			x: number;
			y: number;
			width: number;
			height: number;
		};
		data?: any;
	};
}
